import React from 'react';

const Loading = () => {
    return (
        <div>
            <div class="spinner-border" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
        </div>
    );
};

export default Loading;